import { X } from 'lucide-react';

export default function Modal({ open, title, description, onClose, children, footer, size = 'md' }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onMouseDown={event => event.target === event.currentTarget && onClose?.()}>
      <div className={`modal-card modal-${size}`}>
        <div className="modal-head"><div><h3>{title}</h3>{description && <p>{description}</p>}</div><button className="icon-btn" onClick={onClose}><X size={18} /></button></div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
